import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  profile: {
    borderBottom: ({ theme }: ThemeFunction<unknown>) =>
      `1px solid ${theme.textColor}`,
  },
};
